export const en = {
  Name: "Name",
  Firstnames: "Firstnames",
  Birthplace: "Birthplace",
  Municipality: "Municipality",
  Unknown: "Unknown",
  "Date of birth": "Date of birth",
  "Living in": "Living in",
  "Marital status": "Marital status",
  "Back to homepage": "Back to homepage",
  "Link to github repository": "Link to github repository",
  "Link to github contributors page": "Link to github contributors page",
  "Link to conduction website": "Link to conduction website",
  "Opens a new window": "Opens a new window",
  "Phone number": "Phone number",
  "Email address": "Email address",
  "Scroll table to the left": "Scroll table to the left",
  "Scroll table to the right": "Scroll table to the right",
  "The JWT validation failed with error message": "The JWT validation failed with error message",
  "The JWT validation was successful": "The JWT validation was successful",
};
